/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * The controller for the custom page.
 */

angular.module('customTemplate')
    .controller('customTemplateController', ['$scope','$routeParams','$location', '$injector','$sce',

        function customTemplateController($scope,$routeParams,$location, $injector, $sce) {

        $scope.message = '';

        if($location.path() === '/info') {
            $scope.message = $sce.trustAsHtml('<h2>Your connection has been ended</h2>');
        } else if($location.path() === '/home') {
            $scope.message = $sce.trustAsHtml('<h3>This server can only be accessed from the application. For more information contact the administrator.</h3>')
        } else  {
            $scope.message = $sce.trustAsHtml('<h2>Unauthorized request</h2>')
        }

        $scope.year = (new Date()).getFullYear();
    }]);